import Row from '../../ResponsiveRow/row';
import React , { JSX } from 'react';
import Styles from './progressionBar.module.scss';
import { ACCESSORYLABEL, VASSTEPPERLABEL } from '../../../utils/constants';
import { ComponentWithContentProps, GenericSBProps } from '../../types';
import { useMultiAccessoryContext } from '../multiItemAccessoryStore/useMultiAccessoryContext';

interface ProgressionBarProps extends GenericSBProps {
  pickYourDeviceLabel: string;
  customizeDeviceLabel: string;
  yourSubscriptionLabel: string;
  vasStepperLabel: string;
  checkoutLabel: string;
  accessoriesLabel: string;
  selectedStep?: string;
  optionalLabelText: string;
}

const ProgressionBar = ({
  content
}: ComponentWithContentProps<ProgressionBarProps>): JSX.Element => {
  /**not needed here in prod-card as it will open only MIA page */
  // const deviceStore = useSelector(deviceSelector);
  // const { multiItemAccessory } = deviceStore;
  const { store } = useMultiAccessoryContext();
  const {  deviceSessionValues } = store;
  // Check if internet summary session exists
  const hasInternetSummarySession =
    typeof window !== 'undefined' &&
    sessionStorage.getItem('one-ecommerce-internetSummary') !== null;

  //progression bar titles
  const steps: any = {};
  if (content?.pickYourDeviceLabel && deviceSessionValues?.hardwareVariant) steps.pickYourDeviceLabel = content.pickYourDeviceLabel;
  if (content?.customizeDeviceLabel  && deviceSessionValues?.hardwareVariant) steps.customizeDeviceLabel = content.customizeDeviceLabel;
  if (content?.yourSubscriptionLabel) steps.yourSubscriptionLabel = content.yourSubscriptionLabel;
  if (content?.vasStepperLabel && hasInternetSummarySession)
    steps.vasStepperLabel = content.vasStepperLabel;
  if (content?.accessoriesLabel) steps.accessoriesLabel = content.accessoriesLabel;
  if (content?.checkoutLabel) steps.checkoutLabel = content.checkoutLabel;
  const selectedStep = content?.selectedStep;
  let selectedIndex: number;
  Object.entries(steps).forEach(([key], index) => {
    if (key === selectedStep) {
      selectedIndex = index;
    }
  });

  return (
    <Row>
      <div className={Styles.steps}>
        <div className={Styles.numbers}>
          {Object.entries(steps)
            .filter((value) => value[1] !== '')
            .filter((value) => {
              if (value[1] === content?.accessoriesLabel) {
                return (selectedStep === ACCESSORYLABEL); // to show accesories label only when recommend accessory is present or if the selected step is accessory
              }
              else {
                return value;
              }
            })
            .map(([key, value]: any, index) => {
              return (
                <div key={key} className={`d-flex ${Styles.step}  ${key === selectedStep ? Styles.active : ''} ${selectedStep === ACCESSORYLABEL ? Styles.accessorybackground : Styles.progressbarBackground} `} >
                  <div
                    className={`${Styles.stepCount} ${key === selectedStep ? Styles.active : ''} ${selectedIndex > index ? Styles.finished : ''
                    }`}
                  >
                    {index + 1}
                  </div>
                  <span>{value}</span>
                  {key === ACCESSORYLABEL && <div className={`${selectedStep === ACCESSORYLABEL ? Styles.accesoriesOptionalText : Styles.optionalText}`}>{content?.optionalLabelText}</div>}
                  {key === VASSTEPPERLABEL && <div className={`${selectedStep === VASSTEPPERLABEL ? Styles.accesoriesOptionalText : Styles.optionalText}`}>{content?.optionalLabelText}</div>}
                </div>
              );
            })}
        </div>
      </div>
    </Row>
  );
};

export default ProgressionBar;
